import truncate from 'html-truncate';
import React from 'react';
import Router, { Link } from 'react-router-dom';

import { BREAK_POINT } from 'constants/responsive';

import Product from 'types/shopify/Product';

import './AccessoriesItem.sass';

interface Props {
    item: Product;
    match: Router.match<{}>;
}

const AccessoriesItem: React.StatelessComponent<Props> = ({ item, match }) => {
    return (
        <div className={`Accessories-item${window.innerWidth < BREAK_POINT ? '-mobile' : ''}`}>
            <Link className="Accessories-item-link" to={`/accessories/${item.id}`}>
                {(item.image && item.image.src)
                    ? (<img className="responsive-img Image" src={item.image.src} />)
                    : ''
                }
                <div className="Title">{item.title}</div>
                {window.innerWidth >= BREAK_POINT && (
                    <span className="Description"><div className="Description-content" dangerouslySetInnerHTML={{ __html: truncate(item.body_html, 125) }} /></span>
                )}
            </Link>
        </div>
    );
};

export default AccessoriesItem;



// WEBPACK FOOTER //
// ./src/components/pages/accessories/AccessoriesItem.tsx